<section>
  <ng-container [formGroup]="this.form">
    <!-- <mat-label [attr.aria-label]="this.ariaLabelText" i18n>{{
      this.label
    }}</mat-label> -->
    <mat-form-field appearance="outline" floatLabel="always">
      <div class="d-flex align-items-center justify-content-around">
        <input
          autocomplete="off"
          [attr.aria-label]="this.ariaLabelInput"
          [id]="this.controlName"
          [name]="this.controlName"
          [title]="this.controlName"
          [type]="this.type"
          [mask]="this.mask"
          matInput
          [formControlName]="this.controlName"
          [placeholder]="this.placeholder"
        />
        <span
          *ngIf="this.icon"
          style="cursor: pointer; padding-right: 25px; margin: 0"
        >
          <img width="26px;" [src]="this.icon" (click)="this.showPassword()" />
        </span>
      </div>
      <!-- <mat-error *ngIf="this.form.controls[this.controlName].invalid" i18n>{{
        this.textError
      }}</mat-error> -->
    </mat-form-field>
  </ng-container>
</section>
